export const convertToOriginEmail = (email: string) => {
    if (email == null) return '';
    if (!email.includes('send.stibee.com')) return email
    const extractOriginMail = email.replace(/@send\.stibee\.com$/g, '');
    const regex = /-(?=[^-]*$)/;
    const originMail = extractOriginMail.replace(regex, '@');
    return originMail;
};
